import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import type { McpProviderUiModule } from './types';

const isCampusLoginIntegration = (integration: ManagedMcpIntegration) => {
  const code = (integration.code || '').toLowerCase();
  const name = (integration.name || '').toLowerCase();
  const description = (integration.description || '').toLowerCase();
  return (
    code.includes('campus_login') ||
    code.includes('campus-login') ||
    name.includes('campuslogin') ||
    name.includes('campus login') ||
    description.includes('campus login')
  );
};

export const campusLoginProviderUiModule: McpProviderUiModule = {
  providerCode: 'campus-login',
  matches: (integration: ManagedMcpIntegration) => isCampusLoginIntegration(integration),
  getUiConfig: () => ({
    providerCode: 'campus-login',
    displayName: 'CampusLogin',
    supportsDynamicClientRegistration: false,
    requireClientId: false,
    requireClientSecret: false,
    showEndpointOverride: false,
    extraAuthFields: [
      {
        key: 'bearerToken',
        label: 'CampusLogin API Key',
        placeholder: 'Paste your X-Api-Key here',
        type: 'password' as const,
      },
    ],
  }),
};
